import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 32, height = 32, customClass, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} fill='none' viewBox='0 0 32 32' class={customClass}>
  <path d='M1.33337 1.33334L30.6667 30.6667' stroke={color} stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M29.3334 21.3333V8.00001C29.3334 7.29277 29.0524 6.61449 28.5523 6.11439C28.0522 5.61429 27.374 5.33334 26.6667 5.33334H17.3334H13.3334M24 24H10.6667L5.33337 29.3333V8.00001C5.33337 7.29277 5.61433 6.61449 6.11442 6.11439' stroke={color} stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
</svg>
